import { createFileRoute } from '@tanstack/react-router';
import { KpiRkkTable } from '@/modules/kpi/kpi-rkks';

export const Route = createFileRoute('/(dashboard)/_dashboard/performance-review/$id/')({
  component: KpiRkkTable,
});
